Я даю согласие на обработку моих
<a class="personal-data" sdLink [routerLink]="'/personal_data'">персональных данных</a>
